import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=1acd72b6&scoped=true&"
import script from "./Stories.vue?vue&type=script&lang=js&"
export * from "./Stories.vue?vue&type=script&lang=js&"
import style0 from "./Stories.vue?vue&type=style&index=0&id=1acd72b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd72b6",
  null
  
)

export default component.exports